// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__6QzLh","modal--auto_height":"Modal_modal--auto_height__2xvOj","modal__close_icon":"Modal_modal__close_icon__2FBA_"};